module.exports = __webpack_public_path__ + "img/f1e4b97.jpg";